import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import Account from "../user/account/Account";
import Recharge from "../user/recharge/Recharge";
import Withdraw from "../user/withdraw/WithDraw";
import HistoryRecharge from "../user/history/HistoryRecharge";
import HistoryWithdraw from "../user/history/HistoryWithdraw";
import HistoryCasino from "../user/history/HistoryCasino";
import HistoryBet from "../user/history/HistoryBet";
import HistoryTransfer from "../user/history/HistoryTransfer";
import Transfer from "../user/transfer/Transfer";
import axios from "axios";

// Import Header để hiển thị ở trên cùng
import Header from "../components/Header";

const PopupMenu = ({ profile, isOpen, isClose, menuActive, getProfile }) => {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [activeOption, setActiveOption] = useState(0);

    const handleOptionClick = (option) => {
        setActiveOption(option);
    };

    useEffect(() => {
        setActiveOption(menuActive);
    }, [menuActive]);

    const [bankCard, setBankCard] = useState(false);
    const menuClick = () => {
        setActiveOption(3);
        setBankCard(true);
    };

    return (
        <>
            {isOpen === true && profile != null && (
                <div className="user-dashboard-wrapper">
                    
                    {/* STYLE GIAO DIỆN TRANG QUẢN LÝ TÀI KHOẢN */}
                    <style>{`
                        .user-dashboard-wrapper {
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100vw;
                            height: 100vh;
                            background-color: #e6e9ee; 
                            z-index: 99999;
                            overflow-y: auto;
                            overflow-x: hidden;
                            font-family: Arial, sans-serif;
                            display: block; 
                        }
                        
                        /* Thanh Topbar màu Đỏ chuẩn */
                        .dashboard-topbar {
                            background: #c92429;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 30px;
                            color: white;
                        }
                        .topbar-left-wrap {
                            display: flex;
                            align-items: center;
                            gap: 15px;
                        }
                        .topbar-left-wrap .close-x {
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                        }
                        .dashboard-topbar h2 {
                            margin: 0;
                            font-size: 18px;
                            font-weight: bold;
                            text-transform: uppercase;
                        }
                        .btn-close-dashboard {
                            display: flex;
                            align-items: center;
                            gap: 5px;
                            cursor: pointer;
                            font-size: 14px;
                            background: rgba(0,0,0,0.15);
                            padding: 6px 12px;
                            border-radius: 4px;
                            transition: background 0.3s;
                        }
                        .btn-close-dashboard:hover {
                            background: rgba(0,0,0,0.3);
                        }

                        /* Cấu trúc phần nội dung chính */
                        .dashboard-container {
                            max-width: 1400px;
                            width: 100%;
                            margin: 30px auto;
                            display: flex;
                            gap: 20px;
                            padding: 0 20px;
                            align-items: flex-start;
                        }

                        /* Cột Menu Trái (Sidebar) */
                        .dashboard-sidebar {
                            width: 250px;
                            background: #2a2e33;
                            border-radius: 5px;
                            height: fit-content;
                            overflow: hidden;
                            flex-shrink: 0;
                        }
                        .dashboard-sidebar ul {
                            list-style: none;
                            padding: 0;
                            margin: 0;
                        }
                        .dashboard-sidebar li {
                            padding: 15px 20px;
                            color: #c9d1d9;
                            font-size: 14px;
                            cursor: pointer;
                            border-bottom: 1px solid #363b42;
                            transition: all 0.3s ease;
                            position: relative;
                        }
                        .dashboard-sidebar li:last-child {
                            border-bottom: none;
                        }
                        .dashboard-sidebar li:hover {
                            background: #363b42;
                            color: #fff;
                        }
                        
                        /* Active Menu */
                        .dashboard-sidebar li.active {
                            background: #5b697e;
                            color: #fff;
                            font-weight: bold;
                        }
                        .dashboard-sidebar li.active::after {
                            content: '';
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            border-top: 6px solid transparent;
                            border-bottom: 6px solid transparent;
                            border-right: 6px solid #fff;
                        }

                        /* ========================================================= */
                        /* KHẮC PHỤC LỖI TRÀN FORM & LỖI CHIỀU CAO (ẢNH BẠN GỬI) */
                        /* ========================================================= */
                        .dashboard-content {
                            flex: 1;
                            min-width: 0; /* Flexbox trick để chống tràn ngang */
                            background: #ffffff;
                            border-radius: 5px;
                            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                            padding: 30px;
                            min-height: 600px;
                            
                            /* Fix lỗi chiều cao bị xẹp do code cũ dùng "float" (như ở ảnh Chuyển ví) */
                            display: flow-root; 
                            
                            /* Nếu bảng biểu cũ bên trong quá to, cho phép cuộn ngang TẠI ĐÂY thay vì đâm thủng nền trắng */
                            overflow-x: auto; 
                        }

                        /* Ép toàn bộ các thẻ div, form, table từ code cũ không được phép to hơn 100% của nền trắng */
                        .dashboard-content div,
                        .dashboard-content form,
                        .dashboard-content table,
                        .dashboard-content p {
                            max-width: 100% !important;
                            box-sizing: border-box;
                        }
                        /* ========================================================= */
                        
                        /* Responsive */
                        @media (max-width: 900px) {
                            .dashboard-container {
                                flex-direction: column;
                            }
                            .dashboard-sidebar {
                                width: 100%;
                            }
                        }
                    `}</style>

                    {/* 1. HIỂN THỊ HEADER CHÍNH CỦA TRANG WEB */}
                    <Header profile={profile} />

                 

                    {/* 3. KHUNG MAIN CHIA 2 CỘT */}
                    <div className="dashboard-container">
                        
                        {/* MENU BÊN TRÁI NHƯ ẢNH MẪU */}
                        <div className="dashboard-sidebar">
                            <ul>
                                <li onClick={() => handleOptionClick(1)} className={activeOption == 1 ? "active" : ""}>
                                    Thông Tin Cá Nhân
                                </li>
                                <li onClick={() => handleOptionClick(2)} className={activeOption == 2 ? "active" : ""}>
                                    Nạp Tiền
                                </li>
                                <li onClick={() => handleOptionClick(3)} className={activeOption == 3 ? "active" : ""}>
                                    Rút Tiền
                                </li>
                                <li onClick={() => handleOptionClick(7)} className={activeOption == 7 ? "active" : ""}>
                                    Chuyển Ví
                                </li>
                                <li onClick={() => handleOptionClick(8)} className={activeOption == 8 ? "active" : ""}>
                                    Báo Cáo Sảnh Game
                                </li>
                                <li onClick={() => handleOptionClick(4)} className={activeOption == 4 ? "active" : ""}>
                                    Lịch Sử Cược
                                </li>
                                <li onClick={() => handleOptionClick(5)} className={activeOption == 5 ? "active" : ""}>
                                    Lịch Sử Nạp Tiền
                                </li>
                                <li onClick={() => handleOptionClick(6)} className={activeOption == 6 ? "active" : ""}>
                                    Lịch Sử Rút Tiền
                                </li>
                                <li onClick={() => handleOptionClick(9)} className={activeOption == 9 ? "active" : ""}>
                                    Lịch Sử Chuyển Ví
                                </li>
                            </ul>
                        </div>

                        {/* NỘI DUNG HIỂN THỊ BÊN PHẢI VỚI NỀN TRẮNG (Đã fix lỗi tràn form) */}
                        <div className="dashboard-content">
                            {activeOption == 1 && <Account profile={profile} menuClick={menuClick} getProfile={getProfile} />}
                            {activeOption == 2 && <Recharge profile={profile} getProfile={getProfile} />}
                            {activeOption == 3 && <Withdraw profile={profile} bankCard={bankCard} getProfile={getProfile} />}
                            {activeOption == 4 && <HistoryBet profile={profile} getProfile={getProfile} />}
                            {activeOption == 5 && <HistoryRecharge profile={profile} getProfile={getProfile} />}
                            {activeOption == 6 && <HistoryWithdraw profile={profile} getProfile={getProfile} />}
                            {activeOption == 7 && <Transfer profile={profile} getProfile={getProfile} />}
                            {activeOption == 8 && <HistoryCasino profile={profile} getProfile={getProfile} />}
                            {activeOption == 9 && <HistoryTransfer profile={profile} getProfile={getProfile} />}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PopupMenu;